<script>
  import SettingField from '../shared/SettingField.svelte';

  export let form;

  const inputClass =
    'h-11 w-full rounded-lg border border-slate-300 bg-white px-3 text-sm text-slate-900 shadow-sm outline-none transition placeholder:text-slate-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-500';
  const textareaClass =
    'min-h-[92px] w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm outline-none transition placeholder:text-slate-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-100';
  const checkboxClass = 'h-4 w-4 rounded border-slate-300 text-blue-600 focus:ring-2 focus:ring-blue-100';
</script>

<div class="grid grid-cols-1 gap-4 md:grid-cols-2">
  <SettingField id="menu-code" label="Code">
    <input id="menu-code" bind:value={form.code} class={inputClass} />
  </SettingField>

  <SettingField id="menu-label" label="Label">
    <input id="menu-label" bind:value={form.label} class={inputClass} />
  </SettingField>

  <SettingField id="menu-description" label="Description" className="md:col-span-2">
    <textarea id="menu-description" bind:value={form.description} rows="3" class={textareaClass}></textarea>
  </SettingField>

  <SettingField id="menu-keywords" label="Keywords">
    <input id="menu-keywords" bind:value={form.keywords} placeholder="home,dashboard,info" class={inputClass} />
  </SettingField>

  <SettingField id="menu-icon" label="Icon">
    <input id="menu-icon" bind:value={form.icon} placeholder="Info" class={inputClass} />
  </SettingField>

  <SettingField id="menu-group" label="Group">
    <input id="menu-group" bind:value={form.menu_group} placeholder="Applications" class={inputClass} />
  </SettingField>

  <SettingField id="menu-sort-order" label="Sort Order">
    <input id="menu-sort-order" type="number" bind:value={form.sort_order} class={inputClass} />
  </SettingField>

  <SettingField id="menu-type" label="Menu Type">
    <select id="menu-type" bind:value={form.menu_type} class={inputClass}>
      <option value="component">Component</option>
      <option value="iframe">IFrame</option>
    </select>
  </SettingField>

  <SettingField id="menu-hotkey" label="Hotkey">
    <input id="menu-hotkey" bind:value={form.hotkey} placeholder="ctrl+d" class={inputClass} />
  </SettingField>

  {#if form.menu_type === 'component'}
    <SettingField id="menu-component" label="Component" className="md:col-span-2">
      <input id="menu-component" bind:value={form.component} placeholder="Faces" class={inputClass} />
    </SettingField>
  {/if}

  {#if form.menu_type === 'iframe'}
    <SettingField id="menu-src" label="URL" className="md:col-span-2">
      <input id="menu-src" bind:value={form.src} placeholder="https://..." class={inputClass} />
    </SettingField>
  {/if}
</div>

<div class="mt-6 border-t border-slate-200 pt-5">
  <h3 class="text-sm font-semibold text-slate-900">Options</h3>

  <div class="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
    <label class="flex items-center gap-3 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm font-medium text-slate-700">
      <input id="menu-visible" type="checkbox" bind:checked={form.visible} class={checkboxClass} />
      Visible
    </label>

    <label class="flex items-center gap-3 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm font-medium text-slate-700">
      <input id="menu-toolbar" type="checkbox" bind:checked={form.toolbar} class={checkboxClass} />
      Toolbar
    </label>

    <label class="flex items-center gap-3 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm font-medium text-slate-700">
      <input id="menu-collapse-menu" type="checkbox" bind:checked={form.collapse_menu} class={checkboxClass} />
      Collapse Menu
    </label>

    <label class="flex items-center gap-3 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm font-medium text-slate-700">
      <input id="menu-disabled" type="checkbox" bind:checked={form.disabled} class={checkboxClass} />
      Disabled
    </label>
  </div>
</div>
